import { cn } from '@/lib/utils';

const STYLES = {
  sale: 'bg-sky-50 text-sky-700 border border-sky-200',
  rent: 'bg-amber-50 text-amber-700 border border-amber-200',
};

export const TransactionTypeBadge = ({ isRental, className }) => (
  <span
    className={cn(
      'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
      isRental ? STYLES.rent : STYLES.sale,
      className,
    )}
  >
    {isRental ? 'For Rent' : 'For Sale'}
  </span>
);
